import React, { useState } from "react";
import { PIPELINE_STEPS } from "variables/constants";
import SearchBar from "components/search/SearchBar";
import SelectOption from "components/select/SelectOption";

const RecruitmentSearchFilter = () => {
    const [selected, setSelected] = useState(null);
    const [stageFilter, setStageFilter] = useState(0); 
    const [positionFilter, setPositionFilter] = useState(0);

    const stageMap = {
        1: "Application",
        2: "Screening",
        3: "Testing",
        4: "Shortlisting",
        5: "Client Endorsement",
        6: "Client Selection",
        7: "References",
        8: "Offer",
        9: "Onboarding",
    };

    const positionMap = {
        1: "Senior Software Engineer",
        2: "UX/UI Designer",
        3: "Product Manager",
        4: "Data Scientist",
        5: "DevOps Engineer",
    };

    const stagesInOrder = Object.values(stageMap);

    return (
        
        <div className="space-y-3">
            <SearchBar
                placeholder="Search candidates..." 
            />

            <div className="grid grid-cols-2 gap-x-2">
                <SelectOption
                    placeholder="All Stages"
                    options={[
                        { label: "All Stages", value: 0 },
                        { label: "Application", value: 1 },
                        { label: "Screening", value: 2 },
                        { label: "Testing", value: 3 },
                        { label: "Shortlisting", value: 4 },
                        { label: "Client Endorsement", value: 5 },
                        { label: "Client Selection", value: 6 },
                        { label: "References", value: 7 },
                        { label: "Offer", value: 8 },
                        { label: "Onboarding", value: 9 },
                    ]}
                    value={stageFilter}
                    onChange={setStageFilter}
                />
                <SelectOption
                    placeholder="All Positions"
                    options={[
                        { label: "All Positions", value: 0 },
                        { label: "Senior Software Engineer", value: 1 },
                        { label: "UX/UI Designer", value: 2 },
                        { label: "Product Manager", value: 3 },
                        { label: "Data Scientist", value: 4 },
                        { label: "DevOps Engineer", value: 5 },
                    ]}
                    value={positionFilter}
                    onChange={setPositionFilter}
                />
            </div>
        </div>
    );
};

export default RecruitmentSearchFilter;